import React from 'react';

export interface RadioGroupItemInternal {
  ref: React.MutableRefObject<HTMLElement | null>;
  propsRef: React.MutableRefObject<{ value: string; disabled: boolean }>;
}

export interface RadioGroupContextT<T extends string | number = any> {
  value: T;
  name: string;
  onChange: (value: T) => void;
}

export const RadioGroupContext = React.createContext<RadioGroupContextT | null>(
  null,
);

export const useRadioGroup = <
  T extends string | number = string | number,
>(): RadioGroupContextT<T> => {
  const context = React.useContext(RadioGroupContext);
  if (!context) {
    throw new Error('RadioItem needs to have a RadioGroup parent');
  }
  return context as RadioGroupContextT<T>;
};
